/**
 * Timezone utility functions for formatting dates/times in the provider's timezone
 */

/**
 * Format a UTC ISO datetime string in the provider's timezone
 * @param utcIsoString - ISO8601 UTC datetime string (e.g., "2026-04-07T14:30:00Z")
 * @param providerTimezone - IANA timezone string (e.g., "Europe/Sofia")
 * @param options - Intl.DateTimeFormat options
 */
export const formatInTimezone = (
  utcIsoString: string,
  providerTimezone: string,
  options?: Intl.DateTimeFormatOptions
): string => {
  const date = new Date(utcIsoString);
  return date.toLocaleTimeString(providerTimezone, options);
};

/**
 * Format a date in the provider's timezone
 * @param utcIsoString - ISO8601 UTC datetime string (e.g., "2026-04-07T14:30:00Z")
 * @param providerTimezone - IANA timezone string (e.g., "Europe/Sofia")
 * @param options - Intl.DateTimeFormat options
 */
export const formatDateInTimezone = (
  utcIsoString: string,
  providerTimezone: string,
  options?: Intl.DateTimeFormatOptions
): string => {
  const date = new Date(utcIsoString);
  return date.toLocaleDateString(providerTimezone, options);
};

/**
 * Format a datetime in the provider's timezone
 * @param utcIsoString - ISO8601 UTC datetime string (e.g., "2026-04-07T14:30:00Z")
 * @param providerTimezone - IANA timezone string (e.g., "Europe/Sofia")
 * @param options - Intl.DateTimeFormat options
 */
export const formatDateTimeInTimezone = (
  utcIsoString: string,
  providerTimezone: string,
  options?: Intl.DateTimeFormatOptions
): string => {
  const date = new Date(utcIsoString);
  return date.toLocaleString(providerTimezone, options);
};
